<pl-container>
  <div class="flex flex-col gap-4 py-4">
    <h1 class="self-center text-center">
      {{ 'home.welcome' | translate: { name: participantFirstName() } }}
    </h1>
    <h5 class="self-center uppercase text-pl-orange-800">
      {{ 'home.your_progress' | translate }}
    </h5>
    <div class="flex h-72 w-full max-w-full justify-between gap-4 px-5">
      <ng-container *ngFor="let cycle of cycleProgress()">
        <pl-donut
          *ngIf="isBigScreen || (!isBigScreen && cycle.isCurrent)"
          class="h-full flex-1 self-center"
          [ngClass]="!isBigScreen && cycle.isCurrent ? 'max-w-full' : 'max-w-[30%]'"
          [percentage]="cycle.percentageCompletion"
          [isLocked]="cycle.isLocked"
          [title]="cycle.title"
          [subtitle]="cycle.subtitle"
        />
      </ng-container>
    </div>
    <div *ngIf="participantProgression()" class="flex flex-col items-center gap-2.5 bg-pl-gray-200 p-5">
      <h5 class="self-center uppercase">
        {{ 'home.take_me_next_step' | translate }}
      </h5>
      <h3 class="flex flex-col items-center sm:flex-row">
        <ng-container *ngIf="participantProgression()?.linkNextStep">
          <span>{{ participantProgression()?.moduleTitle }}&nbsp;</span><span class="hidden sm:block">&bull;&nbsp;</span
          ><span>{{ participantProgression()?.moduleName }}</span>
        </ng-container>
        <ng-container *ngIf="!participantProgression()?.linkNextStep">
          {{ 'home.review_past_modules' | translate }}
        </ng-container>
      </h3>
      <pl-button
        class="!w-fit"
        [variant]="ButtonVariant.green"
        [padding]="ButtonPadding.big"
        (click)="goToNextStep(participantProgression()?.linkNextStep, $event)"
      >
        <div class="uppercase">
          <ng-container *ngIf="participantProgression()?.linkNextStep">
            {{ participantProgression()?.stepTitle }}<span>&nbsp;&bull;&nbsp;</span
            >{{ participantProgression()?.stepName }}
          </ng-container>
          <ng-container *ngIf="!participantProgression()?.linkNextStep">
            {{ 'home.open_menu' | translate }}
          </ng-container>
        </div>
      </pl-button>
    </div>

    <div class="grid grid-rows-2 gap-5 bg-pl-gray-200 p-5 sm:grid-cols-2 sm:grid-rows-1">
      <pl-button
        [isDisabled]="!participantProgression()?.linkNextLifeActs"
        [variant]="ButtonVariant.white"
        [padding]="ButtonPadding.big"
        (click)="goToCurrentLifeActs(participantProgression()?.linkNextLifeActs, $event)"
      >
        {{ 'home.take_me_current_lifeacts' | translate }}
      </pl-button>
      <pl-button
        class="block h-full"
        [variant]="ButtonVariant.white"
        [padding]="ButtonPadding.big"
        (click)="goToLifeChanges($event)"
      >
        {{ 'home.take_me_lifechanges' | translate }}
      </pl-button>
    </div>

    <div class="flex flex-col justify-between gap-4 sm:flex-row">
      <pl-home-section
        [title]="'home.help_faq' | translate"
        [text]="'home.browse_faq' | translate"
        [buttonLabel]="'home.help_faq' | translate"
        (buttonClicked)="goToHelpAndFaq()"
      />
      <pl-home-section
        [title]="'home.support' | translate"
        [text]="'home.get_in_touch' | translate"
        [buttonLabel]="'home.contact_us' | translate"
        (buttonClicked)="contactUs()"
      />
    </div>
  </div>
</pl-container>
